import React from 'react';
import { Progress } from 'antd';
import Text from '../Text';
import './Progress.less';

export type ProgressProps = {
  percent?: number;
  status?: 'active' | 'exception' | 'success' | 'normal';
  showInfo?: boolean;
  strokeLinecap?: 'butt' | 'square' | 'round';
  type?: 'circle' | 'dashboard' | 'line';
  size?: 'default' | 'small';
  strokeColor?: {};
  labelRows?: 1 | 2 | 3 | null;
  label?: string;
  labelLevel?: 1 | 2 | 3 | 4;
  style?: React.CSSProperties;
  width?: number;
  trailColor?: string;
  format?: (percent?: number, successPercent?: number) => React.ReactNode;
};

const TProgress: React.FC<ProgressProps> = ({
  label,
  labelRows = 1,
  labelLevel = 3,
  percent = 0,
  type,
  status,
  showInfo,
  strokeColor,
  strokeLinecap,
  style,
  width,
  trailColor,
  format,
}) => {
  return (
    <div>
      {label && (
        <Text bold rows={labelRows} level={labelLevel}>
          {label}
        </Text>
      )}
      <Progress
        width={width}
        style={style}
        showInfo={showInfo}
        type={type}
        percent={percent}
        status={status}
        trailColor={trailColor}
        strokeColor={strokeColor}
        strokeLinecap={strokeLinecap}
        format={format}
      />
    </div>
  );
};

export default TProgress;
